import React, { useState, useContext, useEffect, useRef } from "react";
import { Modal, Select, Input, Button, message } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./conopsrefinesearch.css"; // Custom CSS for styling
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import apiClientconops from "../../../ApiEndpoint/apiClientconops";
import apiUrlconops from "../../../ApiEndpoint/configconops";
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import qs from 'qs';
import { from, BehaviorSubject } from 'rxjs';
import { CalendarOutlined } from "@ant-design/icons";


const { Option } = Select;



const ConopsRefineSearch = ({ open, onClose }) => {
    const { setRefineSearchProjectObject, setSelectedOpenSearchValue, setSelectedState, setSelectedCounty, setSelectedCity, setSelectedFacility, setSelectedFacilityType, setRegisterId, setCountyObject } = useContext(ConopsContext);
    const [States_Names, setStateNames] = useState([]);

    const searchStateSubject = useRef(new BehaviorSubject(''));

    const [refineSearchFormData, setRefineSearchFormData] = useState({
        project_region: null,
        project_state: null,
        project_operator: "",
        min_revenue: "",
        max_revenue: "",
        min_population: "",
        max_population: "",
        contract_end_end: null,
        project_scope: null,
        total_design_flow: "",
        population_density: "",

    });

    const [lastSearchedValues, setLastSearchedValues] = useState({
        project_region: null,
        project_state: null,
        project_operator: "",
        min_revenue: "",
        max_revenue: "",
        min_population: "",
        max_population: "",
        contract_end_end: null,
        project_scope: null,
        total_design_flow: "",
        population_density: "",
    });

    const handleChange = (field, value) => {
        setRefineSearchFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleReset = () => {
        if (!isFormValid(refineSearchFormData)) {
            message.error("Please select at least one field before searching.");
            return;
        }

        setRefineSearchFormData({
            project_region: null,
            project_state: null,
            project_operator: "",
            min_revenue: "",
            max_revenue: "",
            min_population: "",
            max_population: "",
            contract_end_end: null,
            project_scope: null,
            total_design_flow: "",
            population_density: "",
        });
    };

    // Convert Date to yyyy-mm-dd
    const formatDate = (date) => {
        if (!date) return null;
        return date.getFullYear();
    };


    // Validation function to check at least one field is filled
    const isFormValid = (refineSearchFormData) => {
        return Object.values(refineSearchFormData).some((val) => {
            if (typeof val === "string") {
                return val.trim() !== ""; // non-empty string
            }
            return val !== null && val !== undefined; // valid non-string values
        });
    };





    const handleSearch = () => {
        if (!isFormValid(refineSearchFormData)) {
            message.error("Please select at least one field before searching.");
            return;
        }
        setSelectedOpenSearchValue("")
        setSelectedState(null)
        setSelectedCounty(null)
        setSelectedCity(null)
        setSelectedFacility(null)
        setSelectedFacilityType(null)
        setRegisterId(null)
        setCountyObject(null)
        const refinesearchpayload = {
            ...refineSearchFormData,
            contract_end_end: formatDate(refineSearchFormData.contract_end_end),
        };

        //console.log(refinesearchpayload);
        setRefineSearchProjectObject(refinesearchpayload)
        setLastSearchedValues(refineSearchFormData);
        onClose();
    };

    const handleClose = () => {
        setRefineSearchFormData(lastSearchedValues); // Restore last searched values
        onClose();
    };

    useEffect(() => {
        const debounceDuration = 300; // milliseconds
        const sub = searchStateSubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            // ...(searchText && { State: searchText }),
                            ...(refineSearchFormData.project_region && { region: refineSearchFormData.project_region }),

                        };
                        const response = await apiClientconops.get(`${apiUrlconops}/opportunity-states`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { opportunity_states: [] } };
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.opportunity_states || [];
                setStateNames(data);
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrlconops, refineSearchFormData.project_region]);

    return (
        <Modal
            open={open}
            centered
            title={null}
            width={800}
            footer={null}
            closable={true}
            onCancel={handleClose}
            styles={{ body: { padding: 0, background: "transparent" } }}
            className="refine-search-modal"
        >
            <div className="conops-refine-search">
                <div className="refine-search-header">
                    <h6 className="refine-search-title pt-0">Refine Search</h6>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button type="primary" danger onClick={handleReset}>Reset</Button>
                        <Button type="primary" onClick={handleSearch}>Search</Button>
                    </div>
                </div>
                <div className="refine-search-box">
                    <div className="refine-row">
                        <div className="refine-label">Region:</div>
                        <div className="refine-field">
                            <Select
                                placeholder="Select Region"
                                style={{ width: "100%" }}
                                value={refineSearchFormData.project_region}
                                onChange={value => handleChange('project_region', value)}
                                size="large"
                                allowClear
                                showSearch
                                optionFilterProp="children"
                            >
                                <Option value="South">South</Option>
                                <Option value="Midwest">Midwest</Option>
                                <Option value="Northeast">Northeast</Option>
                                <Option value="West">West</Option>
                            </Select>
                        </div>
                    </div>
                    <div className="refine-row">
                        <div className="refine-label">State:</div>
                        <div className="refine-field">
                            <Select
                                placeholder="Select State"
                                style={{ width: "100%" }}
                                value={refineSearchFormData.project_state}
                                onChange={value => handleChange('project_state', value)}
                                size="large"
                                allowClear
                                showSearch
                                optionFilterProp="children"
                            >
                                {States_Names.map(opt => (
                                    <Option key={opt.state} value={opt.state}>
                                        {opt.state}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className="refine-row">
                        <div className="refine-label">Operator:</div>
                        <div className="refine-field conops-input-field">
                            <Input
                                placeholder="Enter Operator"
                                value={refineSearchFormData.project_operator}
                                onChange={e => handleChange('project_operator', e.target.value)}
                                size="large"
                                allowClear
                            />
                        </div>
                    </div>
                    <div className="refine-row">
                        <div className="refine-label">Estimated Contract Revenue:</div>
                        <div className="refine-field refine-inline">
                            <span className="refine-label-mini">Min:</span>
                            <Input
                                placeholder="Enter Value"
                                value={refineSearchFormData.min_revenue}
                                onChange={(e) => {
                                    // Allow only numbers
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("min_revenue", cleanedValue);
                                }}
                                size="large"
                                style={{ width: 120 }}
                                allowClear
                                inputMode="numeric"     // removes up/down arrows on mobile
                                pattern="[0-9]*"        // prevents non-numeric input
                            />
                            <span className="refine-label-mini ml">Max:</span>
                            <Input
                                placeholder="Enter Value"
                                value={refineSearchFormData.max_revenue}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("max_revenue", cleanedValue);
                                }}
                                size="large"
                                style={{ width: 120 }}
                                allowClear
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                        </div>
                    </div>
                    <div className="refine-row">
                        <div className="refine-label">Population Served:</div>
                        <div className="refine-field refine-inline">
                            <span className="refine-label-mini">Min:</span>
                            <Input
                                placeholder="Enter Value"
                                value={refineSearchFormData.min_population}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("min_population", cleanedValue);
                                }}
                                size="large"
                                style={{ width: 120 }}
                                allowClear
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                            <span className="refine-label-mini ml">Max:</span>
                            <Input
                                placeholder="Enter Value"
                                value={refineSearchFormData.max_population}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("max_population", cleanedValue);
                                }}
                                size="large"
                                style={{ width: 120 }}
                                allowClear
                                inputMode="numeric"
                                pattern="[0-9]*"

                            />
                        </div>
                    </div>
                    <div className="refine-row">
                        <div className="refine-label">End of Contract Date:</div>
                        <div className="refine-field datepicker-wrapper">
                            <DatePicker
                                selected={refineSearchFormData.contract_end_end}
                                onChange={date => handleChange('contract_end_end', date)}
                                placeholderText="Select Year"
                                dateFormat="yyyy"
                                className="refine-datepicker"
                                isClearable
                                showYearPicker           // ✅ Show only years
                                yearDropdownItemNumber={50}
                                scrollableYearDropdown
                            />
                            <span className="calendar-icon">
                                <CalendarOutlined />
                            </span>
                        </div>
                    </div>

                    <div className="refine-row">
                        <div className="refine-label">Scope:</div>
                        <div className="refine-field">
                            <Select
                                placeholder="Select Scope"
                                style={{ width: "100%" }}
                                value={refineSearchFormData.project_scope}
                                onChange={value => handleChange('project_scope', value)}
                                size="large"
                                allowClear
                                showSearch
                                optionFilterProp="children"
                            >
                                <Option value="WTP">WTP</Option>
                                <Option value="WWTP">WWTP</Option>
                                <Option value="WTP_WWTP">WTP_WWTP</Option>
                            </Select>
                        </div>
                    </div>

                    <div className="refine-row">
                        <div className="refine-label">Total Designed Capacity:</div>
                        <div className="refine-field conops-input-field">
                            <Input
                                placeholder="Enter MGD Values(LESS THAN)"
                                value={refineSearchFormData.total_design_flow}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("total_design_flow", cleanedValue);
                                }}
                                size="large"
                                allowClear
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                        </div>
                    </div>

                    <div className="refine-row">
                        <div className="refine-label">Population Density:</div>
                        <div className="refine-field conops-input-field">
                            <Input
                                placeholder="Enter Population Density Values per Sq/M (LESS THAN)"
                                value={refineSearchFormData.population_density}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/\D/g, "");
                                    handleChange("population_density", cleanedValue);
                                }}
                                size="large"
                                allowClear
                                inputMode="numeric"
                                pattern="[0-9]*"
                            />
                        </div>
                    </div>


                </div>
            </div>
        </Modal>
    );
};

export default ConopsRefineSearch;

